import { Elements } from '@stripe/react-stripe-js';
import dynamic from 'next/dynamic';
import Modal from '@/components/Modals/Core';
import SidebarModal from '@/components/Modals/Sidebar';
import { SidebarHeaderProvider } from '@/components/Modals/Sidebar/context/SidebarHeaderContext';
import { getStripe } from '@/stripe';
import { SwitchToYearlyModalHeader } from './header';
import ModalSkeleton from './skeleton';
import { SwitchToYearlyModalScreenName } from './types';

// Reached from the top bar's "Switch to yearly" nudge, which renders on every
// page for subscribers — but `SidebarModal` only mounts its children once the
// sidebar opens, so splitting the screens keeps the checkout stack out of the
// main bundle until the nudge is clicked (DEV-6485).
//
// The screen itself shows this same skeleton while its proration query is in
// flight, so using it as the chunk's loading state means the sidebar opens
// straight into the loading shape rather than showing a header over an empty
// panel first. Padding matches the screen's own so nothing shifts on swap.
const SwitchToYearlyModalScreens = dynamic(() => import('./screens'), {
  ssr: false,
  loading: () => <div aria-label="Loading" aria-live="polite" className="flex h-full flex-col px-6 pt-[52px] pb-20" role="status">
      <ModalSkeleton />
    </div>
});
interface SwitchToYearlyModalProps {
  children?: React.ReactNode;
  initial?: SwitchToYearlyModalScreenName;
  onOpenChange?: (open: boolean) => void;
  open?: boolean;
}
const SwitchToYearlyModal = ({
  open,
  onOpenChange,
  children,
  initial = SwitchToYearlyModalScreenName.SwitchToYearly
}: SwitchToYearlyModalProps) => {
  return <Elements stripe={getStripe()} data-sentry-element="Elements" data-sentry-component="SwitchToYearlyModal" data-sentry-source-file="modal.tsx">
      <SidebarHeaderProvider data-sentry-element="SidebarHeaderProvider" data-sentry-source-file="modal.tsx">
        <SidebarModal onOpenChange={onOpenChange} open={open} trigger={children} data-sentry-element="SidebarModal" data-sentry-source-file="modal.tsx">
          {/*
           * Initial screen can be inferred, but setting it
           * explicitly prevents framer motion from animating
           * the first screen in.
           */}
          <Modal.ScreenContainer initial={initial} data-sentry-element="Modal.ScreenContainer" data-sentry-source-file="modal.tsx">
            <SwitchToYearlyModalHeader data-sentry-element="SwitchToYearlyModalHeader" data-sentry-source-file="modal.tsx" />
            <SwitchToYearlyModalScreens data-sentry-element="SwitchToYearlyModalScreens" data-sentry-source-file="modal.tsx" />
          </Modal.ScreenContainer>
        </SidebarModal>
      </SidebarHeaderProvider>
    </Elements>;
};
export default SwitchToYearlyModal;